import { useEffect, useState } from 'react'
import { useSetRecoilState } from 'recoil';
import { WSPScorecardAtom } from '../../../State/WSPScorecard.Atom';
import { useParams } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import { DashboardBase } from '../../../Component/Common/Components/Dashboard/Base/DashboardBase';
import { DashboardSectionType } from '../../../Component/Model/Enum/DashboardType';
import { ChartType } from '../../../Component/Model/Enum/ChartType';
import { WSPScorecardService } from '../../../Component/Api/WSPScorecard/WSPScorecardService';
import { getDateAsString } from '../../../Helpers/DateFormatter';
const hash = require("object-hash");

export const WSPDashboardBasePage = () => {

    const setWspScored = useSetRecoilState(WSPScorecardAtom);
    const { WSPScorecardId } = useParams<{ WSPScorecardId: string }>();
    const scorecardTypeId = "47";
    const [wspReportPeriodDateFrom, setWSPReportPeriodDateFrom] = useState<string | undefined>();
    const [wspReportPeriodDateTo, setWSPReportPeriodDateTo] = useState<string | undefined>();
    const [atrReportPeriodDateFrom, setATRReportPeriodDateFrom] = useState<string | undefined>();
    const [atrReportPeriodDateTo, setATRReportPeriodDateTo] = useState<string | undefined>();
    const [organisationName, setOrganisationName] = useState<string | undefined>();
    const [organisationId, setOrganisationId] = useState<string>("");
    const [scorecardName, setScorecardName] = useState<string>("");
    const [scorecardYear, setScorecardYear] = useState<number | undefined>();

    const chartOptions = { WSPScorecardId, organisationId };
    const hashString = hash(chartOptions);

    useEffect(() => {
        fetchScorecard();
    }, [])

    const fetchScorecard = async () => {
        let scorecard = await WSPScorecardService.getScorecard(WSPScorecardId);
        setWSPReportPeriodDateFrom(getDateAsString(scorecard.data.startDate));
        setWSPReportPeriodDateTo(getDateAsString(scorecard.data.endDate));
        setScorecardName(scorecard.data.name);
        setOrganisationName(scorecard.data.organisationName);
        setOrganisationId(scorecard.data.organisationId.toString());

        const startDate = new Date(scorecard.data.startDate);
        setScorecardYear(startDate.getFullYear());

        const atrReportPeriodDateFrom = new Date(startDate);
        atrReportPeriodDateFrom.setFullYear(atrReportPeriodDateFrom.getFullYear() - 1);
        setATRReportPeriodDateFrom(getDateAsString(atrReportPeriodDateFrom));

        const endDate = new Date(scorecard.data.endDate);     

        const atrReportPeriodDateTo = new Date(endDate);
        atrReportPeriodDateTo.setFullYear(atrReportPeriodDateTo.getFullYear() - 1);
        setATRReportPeriodDateTo(getDateAsString(atrReportPeriodDateTo));
    }

    useEffect(() => {
        setWspScored({ wspScorecardId: WSPScorecardId, wspScorecardName: scorecardName, organisationId: organisationId, organisationName: organisationName, wspReportPeriodDateFrom: wspReportPeriodDateFrom, wspReportPeriodDateTo: wspReportPeriodDateTo, atrReportPeriodDateFrom: atrReportPeriodDateFrom, atrReportPeriodDateTo: atrReportPeriodDateTo});
    }, [WSPScorecardId, scorecardName, organisationId, wspReportPeriodDateFrom, wspReportPeriodDateTo, atrReportPeriodDateFrom, atrReportPeriodDateTo, organisationName])

    const chartOnClick = (chartType: ChartType, label: string) => {

    }

    const getAvailableChartElements = () => {
        let chartTypeList: ChartType[] = [];

        chartTypeList = [
            ChartType.WSPCostAndHeadcountOFOCodeChart,
            ChartType.ATRCostAndHeadcountOFOCodeChart,
            ChartType.WSPCostAndInterventionChart,
            ChartType.ATRCostAndInterventionChart,
            ChartType.WSPCostAndHeadcountTrainingChart,
            ChartType.ATRCostAndHeadcountTrainingChart,
            ChartType.WorkforceProfileOfoMajorGroupSummary
        ]

        return chartTypeList;
    }

    return (
        <>
            <Typography variant='h4'>
                Dashboard
            </Typography>
            <Grid container spacing={2} mt={1}>
                <Grid item xs={12}>
                    <DashboardBase
                        key={hashString}
                        isVisible={true}
                        scorecardId={WSPScorecardId}
                        scorecardYear={scorecardYear}
                        scorecardTypeId={scorecardTypeId}
                        heading="WSP/ATR Dashboard"
                        dashboardSectionType={DashboardSectionType.wsp}
                        chartOptions={chartOptions}
                        onClick={chartOnClick}
                        availableChartElements={getAvailableChartElements()}
                    />
                </Grid>
            </Grid>
        </>
    )
}
